// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
var JSONdata = JSON.parse(JSON.stringify(require('../assets/environment-variables.json')));
export const environment = {
  production: false,
  ENVIRONMENT: "#{ENVIRONMENT}#",
  INSTANCE: "#{INSTANCE}#",
  WEBAPIURL: '#{WEBAPIURL}#',
  USERAPIURL: 'http://localhost:51165/',
  AUTHAPIURL: 'http://localhost:51165/api/Auth',
  // this one points to jobs, because jobs API calls media API internally
  MediaWebApiUrl: 'https://devapi.alcoa.com/utility/media.TEST/v1/',
  AZURESUBSCRIPTIONKEY: JSONdata["dev"]["AZURESUBSCRIPTIONKEY"],
  GoogleMapKey:  JSONdata["dev"]["GoogleMapKey"],
  ArcGISMapKey: JSONdata["dev"]["ArcGISMapKey"],
  token: '',
  APIM_Trace: 'true',
  clientID: '#{CLIENTID}#',
  authority: 'https://login.microsoftonline.com/37a72eb7-1faf-49d3-9ddc-6b923b751bc0/',
  validateAuthority: true,
  redirectUri: '#{REDIRECTURI}#',
  cacheLocation: 'localStorage',
  postLogoutRedirectUri: '#{POSTLOGOUTREDIRECTURI}#',
  consentScopes: ['#{CONSENTSCOPES}#', 'group.read.all'],
  apiScope: ['#{CONSENTSCOPES}#'],
  graphScope: ['group.read.all'],
  unprotectedResources: ['https://www.microsoft.com/en-us/'],
  graphAPI: 'https://graph.microsoft.com/v1.0/',
  correlationId: JSONdata["dev"]["correlationId"],
  CSE: 37,
  ENTRYLEADER: 25,
  FIRECREWROLE: 26,
  FIRECAPTAINROLE: 27,
  // Allowed File Types are doc, docx, xls, xlsx, ppt, pptx, jpg, jpeg, png, gif, pdf.
  ALLOWEDFILETYPES: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/msword,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel,application/pdf,application/vnd.openxmlformats-officedocument.presentationml.presentation,application/vnd.ms-powerpoint,image/png,image/gif,image/jpeg,image/jpeg',
  // Max attachment file size in bytes
  MAXIMUMATTACHMENTFILESIZE: 100000000, // 10MB
  WPSSUPADM: JSONdata["dev"]["WPSSUPADM"],
  WPSUSRADM: JSONdata["dev"]["WPSUSRADM"],
  pendoApiSettings: {
    webApiKey: JSONdata["dev"]["pendoWebApi"],
    enablePendoApi: true
  },
  DASURL : 'https://devapi.alcoa.com/Alcoa.DAS.TEST/v1',
  DASASSETMAINTENACESUBSCRIPTIONKEY : JSONdata["dev"]["DASASSETMAINTENACESUBSCRIPTIONKEY"],
  appInsights: {
    instrumentationKey: JSONdata["dev"]["appInsightsInstrumentationKey"],
    connectionString: JSONdata["dev"]["appInsightsConnectionString"]
  }
};
